import {
  ArchiveBoxIcon,
  CouponIcon,
  FeaturedAdsIcon,
  GameIcon,
  PhotoIcon,
  PlaylistIcon,
  QuestionMarkCircleIcon,
  SpecialOfferIcon,
  SystemIcon,
  VideoIcon,
  WalletIcon,
} from "assets";
import { Authorities } from "props/authoritries";

export const Menus = [
  {
    title: "System Setup",
    icon: SystemIcon,
    ref: "",
    children: [
      {
        title: "Users & Roles",
        ref: "",
        children: [
          {
            title: "Users",
            ref: "/system_setup/user",
            permission: Authorities.LIST_CMS_USER,
          },
          {
            title: "Roles",
            ref: "/system_setup/role",
            permission: Authorities.LIST_CMS_ROLE,
          },
        ],
      },
      {
        title: "Permisson",
        ref: "",
        children: [
          {
            title: "Module Permission",
            ref: "/system_setup/permisson",
            permission: Authorities.LIST_CMS_PERMISSION,
          },
        ],
      },
      // {
      //   title: "Module",
      //   ref: "/system_setup/module",
      //   permission: Authorities.LIST_MODULE,
      // },
    ],
  },
  {
    title: "Membership Plan",
    icon: WalletIcon,
    ref: "",
    children: [
      {
        title: "Commercial Membership Plan",
        ref: "",
        children: [
          {
            title: "Package",
            ref: "/membership_plan/packages",
            permission: Authorities.LIST_COMMERCIAL_PACKAGE,
          },
          {
            title: "Commercial Membership",
            ref: "/membership_plan/commercial_membership",
            permission: Authorities.LIST_COMMERCIAL_MEMBERSHIP_DURATION,
          },
          {
            title: "Create Membership Plan",
            ref: "/membership_plan/create_membership_plan",
            permission: Authorities.LIST_COMMERCIAL_MEMBERSHIP,
          },
        ],
      },
      {
        title: "DCDD Membership Plan",
        ref: "/membership_plan/dcdd_membership",
        permission: Authorities.LIST_DCDD_MEMBERSHIP_PLAN,
      },
    ],
  },
  {
    title: "User Management",
    icon: PlaylistIcon,
    ref: "",
    children: [
      {
        title: "Commercial User",
        ref: "",
        children: [
          {
            title: "Users",
            ref: "/user_mamagement/commercial_user/users",
            permission: Authorities.LIST_COMMERCIAL_USER,
          },
        ],
      },
      {
        title: "DCDD User",
        ref: "",
        children: [
          {
            title: "Users",
            ref: "/user_mamagement/dcdd_user/users",
            permission: Authorities.LIST_DCDD_USER,
          },
          {
            title: "Bulk Registration",
            ref: "/user_mamagement/dcdd_user/bulk_registration",
            permission: Authorities.CREATE_BULK_REGISTRATION,
          },
        ],
      },
    ],
  },
  {
    title: "Featured Ads",
    icon: FeaturedAdsIcon,
    ref: "/featured_ads",
    permission: [
      Authorities.LIST_FEATURED_ADS,
    ],
  },
  {
    title: "Video",
    icon: VideoIcon,
    ref: "/video",
    permission: [
      Authorities.LIST_GROUP,
      Authorities.LIST_CATEGORY,
      Authorities.LIST_SERIES,
      Authorities.LIST_SEASON,
      Authorities.LIST_EPISODE,
      Authorities.LIST_VIDEO,
    ],
  },
  {
    title: "Chey Chey",
    icon: GameIcon,
    ref: "/cheychey",
    permission: [
      Authorities.LIST_GROUP,
    ],
  },
  {
    title: "Avatar",
    icon: PhotoIcon,
    ref: "/avatar",
    permission: [
      Authorities.LIST_FEATURED_ADS,
    ],
  },
  {
    title: "Coupon",
    icon: CouponIcon,
    ref: "/membership_plan/coupon",
    permission: Authorities.LIST_COUPON,
  },
  {
    title: "Special Offer",
    icon: SpecialOfferIcon,
    ref: "/special-offer",
    permission: Authorities.LIST_COUPON,
  },
  {
    title: "FAQ",
    icon: QuestionMarkCircleIcon,
    ref: "/faq",
    permission: Authorities.LIST_FAQ,
  },
  {
    title: "Reports",
    icon: ArchiveBoxIcon,
    ref: "",
    children: [
      {
        title: "Payment",
        ref: "",
        children: [
          {
            title: "RMA Payment",
            ref: "/report/rma_payment",
            permission: Authorities.LIST_RMA_PAYMENT,
          },
          {
            title: "Stripe Payment",
            ref: "/report/stripe_payment",
            permission: Authorities.LIST_STRIPE_PAYMENT,
          },
          {
            title: "InApp Purchase Payment",
            ref: "/report/in_app_payment",
            permission: Authorities.LIST_STRIPE_PAYMENT,
          },
        ],
      },
      {
        title: "Active User",
        ref: "",
        children: [
          {
            title: "Commercial",
            ref: "/report/active_user/commercial_user",
            permission: Authorities.LIST_COMMERCIAL_ACTIVE_USER,
          },
          {
            title: "DCDD",
            ref: "/report/active_user/dcdd_user",
            permission: Authorities.LIST_DCDD_ACTIVE_USER,
          },
        ],
      },
      {
        title: "New registration",
        ref: "",
        children: [
          {
            title: "Commercial",
            ref: "/report/new_register/commercial_user",
            permission: Authorities.LIST_COMMERCIAL_NEW_REGISTARTION,
          },
          {
            title: "DCDD",
            ref: "/report/new_register/dcdd_user",
            permission: Authorities.LIST_DCDD_NEW_REGISTARTION,
          },
        ],
      },
      {
        title: "DCDD Report",
        ref: "/report/dcdd_report",
        permission: Authorities.LIST_DCDD_USER,
      },
      {
        title: "Commercial Report",
        ref: "/report/commercial_report",
        permission: Authorities.LIST_DCDD_USER,
      },
      {
        title: "Video Count",
        ref: "/report/video_view_count",
        permission: Authorities.LIST_VIDEO_COUNT,
      },
      {
        title: "Email Log",
        ref: "/report/email_log",
        permission: Authorities.LIST_EMAIL_LOGS,
      },
    ],
  },
];
